function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M6.348,4V44.609H7.435a45.007,45.007,0,0,1,19.077,4.519l.488.258.488-.258a45.007,45.007,0,0,1,19.077-4.519h1.087V4H46.565A45.137,45.137,0,0,0,27,8.569,45.137,45.137,0,0,0,7.435,4ZM8.522,6.425a45.334,45.334,0,0,1,17.391,4.138V46.354A45.894,45.894,0,0,0,8.522,42.393Zm36.957,0V42.393a45.894,45.894,0,0,0-17.391,3.961V10.563A45.334,45.334,0,0,1,45.478,6.425ZM2,9.8V49.25H3.087a59.608,59.608,0,0,1,23.472,4.541L27,54l.442-.208A59.608,59.608,0,0,1,50.913,49.25H52V9.8H49.826v37.21c-13.26.24-22.219,4.224-22.826,4.505-.607-.281-9.566-4.265-22.826-4.505V9.8Z",
  transform: "translate(-2 -4)"
});

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default ForwardRef;